import { useQuery } from "@tanstack/react-query";

import { getFarmFieldListAtPointInTime, getFarmFieldListAtPointInTimeAdmin } from "services";

import { getEnvironment, getFarmIdFromLocalStorage } from "utils";

import { GET_FARM_FIELD_LIST_AT_POINT_IN_TIME } from "consts";

import { FieldListField } from "models";

export const useGetFarmFieldListAtPointInTime = ({ date, farmId, enabled = true }: { date: string; farmId?: string; enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;
  const farmIdToUse = isAdmin ? farmId : getFarmIdFromLocalStorage();

  const queryFn = isAdmin ? getFarmFieldListAtPointInTimeAdmin : getFarmFieldListAtPointInTime;

  return useQuery<FieldListField[]>({
    queryKey: [GET_FARM_FIELD_LIST_AT_POINT_IN_TIME, farmIdToUse, date],
    queryFn: () => queryFn({ farmId: farmIdToUse, date }),
    refetchOnMount: "always",
    enabled: enabled && !!farmId && !!date,
  });
};
